import React from "react";
import ReactDOM from "react-dom";
import styles from "./ImageModal.module.scss";
import useBlockScroll from './../../hooks/useBlockScroll';
import { RxCross2 } from "react-icons/rx";

const Modal = ({
  modalOpen,
  closeModal,
  heading,
  children,
  doNotClose = false,
  className = "",
}) => {
  useBlockScroll(modalOpen)
  if (!modalOpen) return null;

  return ReactDOM.createPortal(
    <div
      className={styles.mainContainer}
      onClick={(e) => {
        e.stopPropagation();
        !doNotClose && closeModal(false);
      }}
    >
      <button
        className={styles.closeButton}
        onClick={(e) => {
          e.stopPropagation();
          closeModal(false);
        }}
      >
        <RxCross2 />
      </button>
      <div
        className={`${styles.modalDiv} ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.modalBody}>{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;